import { render, staticRenderFns } from "./index.vue?vue&type=template&id=771ca5b5&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=771ca5b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771ca5b5",
  null
  
)

export default component.exports